// The OpenCloudSecurity mark from the mocks (design/isomorphic/src/core/logo.tsx): a cloud with
// a keyhole on the brand gradient.
import { useT } from "../i18n";
import { cn } from "./cn";

export function LogoMark({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        "inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-[10px] bg-gradient-to-br from-primary to-secondary text-white shadow-sm",
        className,
      )}
      aria-hidden
    >
      <svg viewBox="0 0 24 24" className="h-[62%] w-[62%]" fill="none">
        <path d="M7.2 18.5a4.6 4.6 0 0 1-.7-9.15 6 6 0 0 1 11.2-1.1 4.6 4.6 0 0 1-.4 10.25H7.2Z" fill="currentColor" fillOpacity="0.95" />
        <circle cx="12" cy="12.4" r="1.7" fill="rgb(var(--primary-default))" />
        <path d="M11.25 13.2h1.5l.35 2.6h-2.2l.35-2.6Z" fill="rgb(var(--primary-default))" />
      </svg>
    </span>
  );
}

export function Logo({ className, tone = "auto" }: { className?: string; tone?: "auto" | "light" }) {
  const t = useT();
  const light = tone === "light";
  return (
    <span className={cn("inline-flex items-center gap-2.5", className)}>
      <LogoMark />
      <span className="leading-none">
        <span className={cn("block font-display text-[15px] font-extrabold tracking-tight", light ? "text-white" : "text-gray-900")}>
          OpenCloud<span className={light ? "text-white/60" : "text-primary"}>Security</span>
        </span>
        <span className={cn("mt-1 block whitespace-nowrap text-[10.5px] uppercase tracking-[0.14em]", light ? "text-white/45" : "text-gray-500")}>
          {t.shell.tagline}
        </span>
      </span>
    </span>
  );
}
